import React from 'react';
import EtelAPI from '../api/EtelAPI';
import EditSectionLabel from './EditSectionLabel';
import EditSectionInput from './EditSectionInput';
import EditSectionDropdown from './EditSectionDropdown';
import EditSectionTextArea from './EditSectionTextArea';
import EditSectionDateTime from './EditSectionDateTime';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Alerts from '../prototypes/Alerts';
import Overlay from './Overlay';

import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from './Dialog';


// Input dialog
class InputDialog extends React.Component{

  constructor( props ){
    super( props );
    this.state = {
      layout: this.props.layout === undefined ? {} : this.props.layout,
      show: this.props.show === undefined ? false : this.props.show,
      title: this.props.title === undefined ? '[No Title]' : this.props.title,
      newitem: this.props.newitem === undefined ? {'title':'No Title'} : this.props.newitem,
      headers: this.props.headers === undefined ? [] : this.props.headers,
      rows: this.props.rows === undefined ? [] : this.props.rows,
      data: this.props.data === undefined ? {} : this.props.data,
      selectedOptions: '',
      options: this.props.options === undefined ? {} : this.props.options,
      currentitem: this.props.currentitem === undefined ? {} : this.props.currentitem,
      optionstore: this.props.optionstore === undefined ? {} : this.props.optionstore
    };
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      layout: nextProps.layout === undefined ? {} : nextProps.layout,
      show: nextProps.show,
      selectedOptions: '',
      title: nextProps.title === undefined ? '[No Title]' : nextProps.title,
      newitem: nextProps.newitem === undefined ? {'title':'No Title'} : nextProps.newitem,
      headers: nextProps.headers === undefined ? [] : nextProps.headers,
      rows: nextProps.rows === undefined ? [] : nextProps.rows,
      data: nextProps.data === undefined ? {} : nextProps.data,
      options: nextProps.options === undefined ? {} : nextProps.options,
      currentitem: nextProps.currentitem === undefined ? {} : nextProps.currentitem,
      optionstore: nextProps.optionstore === undefined ? {} : nextProps.optionstore
    } );
  }

  onChangeMultiDropdownItem( currentKey,selectedOption ){
    let currentitem = this.state.currentitem;
    let tempstring = '';

    for( var index = 0; index < selectedOption.length; index++ ) {
      const option = selectedOption[ index ];
      tempstring += option.value + ',';
    }
    /*
    Remove the last comma
    */
    currentitem[currentKey] = tempstring.substring( 0,tempstring.length - 1 );
    this.setState( {selectedOptions: selectedOption, currentitem:currentitem } );

  }

  onChangeItem( fieldKey, e ) {
    let currentitem = this.state.currentitem;
    if( fieldKey !== undefined ){
      currentitem[fieldKey] = e.target.value;
      this.setState( {
        currentitem: currentitem
      } );
    }

  }

  /*
  NOTE: ALL actions MUST be PUSH for this to work.
  */
  onDialogConfirm( e ){
    let data = this.state.currentitem;
    const { dispatch } = this.props;
    const Bugsnag = dispatch.bugsnag;
    const layout = this.state.layout;
    const section = layout.section;
    const title = section.title;
    let options = this.state.options;
    let endpoint = options.endpoint;
    let api = new EtelAPI ( endpoint );
    let alerts = new Alerts( Bugsnag, dispatch );

    api.insert( data ).then( ( result ) => {

      alerts.SUCCESS( title, 'Request Processed Successfully!', 5000 );

    } ).catch( ( error ) => {

      alerts.CRITICAL( title, error );

    } );

    if( this.props.onCancel !== undefined ) {
      this.props.onCancel( e );
    }

  }

  createDialogEditControl( field, item, mode, rowindex ) {
    let type = 'label';
    let label = '';
    let column = '';
    let precision = 0;
    let canedit = true;
    let placeholder = '';
    let options = [];
    let routes = {};
    let routekey = '';
    let isNew = mode === 'NEW' ? true : false;

    for( var key in Object.keys( field ) ) {

      let property = Object.keys( field )[key];

      if( property === 'type' ){
        type = field.type;
      }

      if( property === 'label' ){
        label = field.label;
      }

      if( property === 'column' ){
        column = field.column;
      }

      if( property === 'canedit' ){
        canedit = field.canedit;
      }

      if( property === 'precision' ){
        precision = field.precision;
      }

      if( property === 'options' ){
        options = field.options;
      }

      if( property === 'routes' ){
        routes = field.routes;
        routekey = routes.routekey;
      }

      if( property === 'placeholder' ){
        placeholder = field.placeholder;
      }
    }

    let onChangeItemEvent = this.onChangeItem.bind( this, column );
    let onChangeMultiDropdownItemEvent = this.onChangeMultiDropdownItem.bind( this,column );
    let rowkey = 'input-dialog-row-' + type.toLowerCase() + '-' + column.toLowerCase();
    let value = item[column];

    if( value === undefined ){
      value='';
    }

    //** CREATE DEFAULT LABEL **//
    let inputcontrol = (
      <div className='input-dialog-detail-view-row' key={rowkey}>
        <div className='input-dialog-detail-view-column'>
          <span className='input-dialog-detail-view-content-label'>{label}</span>
        </div>
        <div className='input-dialog-detail-view-column'>
          <EditSectionLabel id={column} column={column} Text={value} width="100%" hilite />
        </div>
      </div>
    );

    if( isNew === true || canedit === true ) {

      //** CREATE TEXTOX CONTROL **//
      if( type === 'textbox' ){
        inputcontrol = (
          <div className='input-dialog-detail-view-row' key={rowkey}>
            <div className='input-dialog-detail-view-column'>
              <span className='input-dialog-detail-view-content-label'>
                {label}
              </span>
            </div>
            <div className='input-dialog-detail-view-column'>
              <EditSectionInput id={column} column={column} value={value} width="100%" onChanged={onChangeItemEvent} />
            </div>
          </div>
        );
      }

      //** CREATE NUMERIC CONTROL **//
      if( type === 'numerictextbox' ) {
        value = parseFloat( value ).toFixed( precision );
        inputcontrol = (
          <div className='input-dialog-detail-view-row' key={rowkey}>
            <div className='input-dialog-detail-view-column'>
              <span className='input-dialog-detail-view-content-label'>{label}</span>
            </div>
            <div className='input-dialog-detail-view-column'>
              <EditSectionInput id={column} column={column} value={value} width="100%" onChanged={onChangeItemEvent} />
            </div>
          </div>
        );
      }

      //** CREATE TEXTAREA CONTROL **//
      if( type === 'textarea' ){
        inputcontrol = (
          <div className='input-dialog-detail-view-row' key={rowkey}>
            <div className='input-dialog-detail-view-column'>
              <span className='input-dialog-detail-view-content-label'>{label}</span>
            </div>
            <div className='input-dialog-detail-view-column'>
              <EditSectionTextArea id={column} column={column} value={value} width="100%" onChanged={onChangeItemEvent} />
            </div>
          </div>
        );
      }

      //** CREATE DATE PICKER CONTROL **//
      if( type === 'date' ){
        inputcontrol = (
          <div className='input-dialog-detail-view-row' key={rowkey}>
            <div className='input-dialog-detail-view-column'>
              <span className='input-dialog-detail-view-content-label'>{label}</span>
            </div>
            <div className='input-dialog-detail-view-column'>
              <EditSectionDateTime id={column} column={column} value={value} width="100%" onChange={onChangeItemEvent} timeFormat={false} />
            </div>
          </div>
        );
      }

      //** CREATE DATE PICKER CONTROL **//
      if( type === 'time' ){
        inputcontrol = (
          <div className='input-dialog-detail-view-row' key={rowkey}>
            <div className='input-dialog-detail-view-column'>
              <span className='input-dialog-detail-view-content-label'>{label}</span>
            </div>
            <div className='input-dialog-detail-view-column'>
              <EditSectionDateTime id={column} column={column} value={value} width="100%" onChange={onChangeItemEvent} dateFormat={false} />
            </div>
          </div>
        );
      }

      //** CREATE DROPDOWN CONTROL **//
      if( type === 'dropdown' ){
        let store = this.state.optionstore;
        let options = [];
        if( ( routekey !== undefined ) || ( routekey !== '' ) ){
          options = store[routekey];
        }
        inputcontrol = (
          <div className='input-dialog-detail-view-row' key={rowkey}>
            <div className='input-dialog-detail-view-column'>
              <span className='input-dialog-detail-view-content-label'>{label}</span>
            </div>
            <div className='input-dialog-detail-view-column'>
              <EditSectionDropdown id={column} column={column} options={options} value={value} width="100%" onChanged={onChangeItemEvent} />
            </div>
          </div>
        );
      }

      //** CREATE STATIC DROPDOWN **//
      if( type === 'staticdropdown' ){
        inputcontrol = (
          <div className='input-dialog-detail-view-row' key={rowkey}>
            <div className='input-dialog-detail-view-column'>
              <span className='input-dialog-detail-view-content-label'>{label}</span>
            </div>
            <div className='input-dialog-detail-view-column'>
              <EditSectionDropdown id={column} column={column} options={options} value={value} width="100%" onChanged={onChangeItemEvent} />
            </div>
          </div>
        );
      }

      //** CREATE MULTI-SELECT DROPDOWN **//
      if( type === 'multiselect' ) {
        const selectedOptions = this.state.selectedOptions;

        inputcontrol = (
          <div className='input-dialog-detail-view-row' key={rowkey}>
            <div className='input-dialog-detail-view-column'>
              <span className='input-dialog-detail-view-content-label'>{label}</span>
            </div>
            <div className='input-dialog-detail-view-column'>
              <Select name={label} placeholder={placeholder} value={selectedOptions} options={options} multi={true} clearable={false} scrollMenuIntoView={true} onChange={onChangeMultiDropdownItemEvent} />
            </div>
          </div>
        );
      }

    }

    return ( inputcontrol );
  }

  onRenderGrid(){
    let gridoptions = this.state.options;
    let currentitem = this.state.currentitem;
    let fields = gridoptions.fields;
    let gridrow = [];
    let rows = [];
    let counter = 0;
    let grid = '';

    for ( var key in fields ){
      let rowkey = 'input-dialog-detail-view-row-' + counter.toString();
      gridrow.push(
        this.createDialogEditControl( fields[key], currentitem, 'NEW', counter )
      );

      rows.push(
        <div key={rowkey}>
          {gridrow}
        </div>
      );
      gridrow = [];
      counter += 1;
    }

    grid = (
      <div>
        {rows}
      </div>
    );

    return ( grid );
  }

  render(){
    return (
      <div className={'input-dialog'}>
        <Overlay show={this.state.show} />
        <Dialog width={33} height={45} show={this.state.show} >
          <DialogHeader caption={this.state.title} closeButton onClose={this.props.onCancel} />
          <DialogBody className={'dialog-body'}>
            {this.onRenderGrid()}
          </DialogBody>
          <DialogFooter className={'dialog-footer'}>
            <button className='input-dialog-cancel-button' style={{'fontSize':'10pt'}} key='btnCancel' onClick={this.props.onCancel}>CANCEL</button>
            <button className='input-dialog-confirm-button' style={{'fontSize':'10pt'}} key='btnConfirm' onClick={this.onDialogConfirm.bind( this )}>CONFIRM</button>
          </DialogFooter>
        </Dialog>
      </div>
    );

  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( InputDialog ) );



// WEBPACK FOOTER //
// ./src/presentation/InputDialog.js